module.exports = __webpack_public_path__ + "img/33_50.9f22cdc3.png";